import Loading from './loading_inex.vue'

export default {
	data() {
		return {
			
		}
	},
	props: {
		loading: {
			type: Boolean | Number,
			default: false
		},
		couleur: {
			type: String,
			default: 'vert'
		},
		action: {
			type: Function,
			default: null
		}
	},
	created(){
		console.log('modale.js created --')
	},
	methods: {
		launchAction(){
			if(this.action) this.action()
		}
	},
	computed:{
	},
	components:{
		Loading
	}
}